export * from './clienteApi';
export * from './errores';



// WEBPACK FOOTER //
// ./src/api/clienteApi/index.ts